import { render } from "./LetterPaginator.vue?vue&type=template&id=39bcd6e1"
import script from "./LetterPaginator.vue?vue&type=script&lang=js"
export * from "./LetterPaginator.vue?vue&type=script&lang=js"

import exportComponent from "/home/noe/Dev/atc/agrotecchain_vue/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__